import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map, catchError } from 'rxjs/operators';
import { Loyaltic } from '../helpers/api-url.constants';
import { AuthService } from '../helpers/auth.service';
import { LoaderService } from '../helpers/loader.service';
import { Router } from '@angular/router';

@Injectable()
export class LoyalticInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private loader: LoaderService , private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (request.url.includes('uploadavatar') ||request.url.includes('cashback') ) {
            //request = request.clone({headers: request.headers.set('enctype', 'multipart/form-data')});
        } else {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
            request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
        }

        const token = this.authService.getToken();
        if (token) {
            request = request.clone({ headers: request.headers.set('Authorization', `Bearer ${token}`) });
        }

        // request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
    request = request.clone({ headers: request.headers.set('ApiKey', `49D7253EC1384D1339CE24786C137`) });
        // const currentUser = this.authenticationService.getToken();
        // if (currentUser) {
        //     request = request.clone({ headers: request.headers.set('Authorization', `Bearer ${currentUser}`) });
        // }
        // setTimeout((() => this.loaderService.emitLoaderInputChange(true)), 50);
        this.loader.show();
        return next.handle(request).pipe(
            map(resp => {
                if (resp instanceof HttpResponse) {

                    this.loader.hide();
                }
                return resp;
                
            }),
            catchError((error: HttpErrorResponse) => {
                console.log('interceptor', error);
                if (error.status === 401 || error.status === 403) {
                  this.authService.resetTokens();
                  this.router.navigate(['home']);
                }
                this.loader.hide();
                return throwError(error);
            })
        );
    }
}
